import React from 'react';
import { MessageCircle, X, Maximize2 } from 'lucide-react';
import { useChatPopup } from '../../contexts/ChatPopupContext';
import { useLocation } from 'react-router-dom';
import './ChatFloatingButton.css';
import { chatNotificationService } from '../../services/notificationService';
import { clickableProps } from '../../utils/a11y';

export const ChatFloatingButton: React.FC = () => {
  const location = useLocation();
  const { 
    isOpen, 
    isMinimized, 
    unreadCount, 
    hasNewMentions, 
    toggleChat, 
    closeChat, 
    maximizeChat 
  } = useChatPopup();

  // Determinar se estamos na página de time tracker
  const isTimeTrackerPage = location.pathname.includes('tracker') || 
                          location.pathname.includes('time') ||
                          location.hash.includes('#tracker') ||
                          location.hash.includes('#time');

  // Se o chat está aberto e não minimizado, não mostrar o botão flutuante
  if (isOpen && !isMinimized) {
    return null;
  }

  const handleClick = () => {
    // Aproveitar o clique pra pedir a permissão de notificação: o navegador só
    // atende esse pedido dentro de um gesto do usuário.
    void chatNotificationService.requestPermissionFromUserGesture();
    toggleChat();
  };

  // A pílula só existe com o chat minimizado: o botão restaura, nunca minimiza.
  const handleRestore = (e: React.MouseEvent) => {
    e.stopPropagation();
    maximizeChat();
  };

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    closeChat();
  };

  return (
    <>
      {/* Botão flutuante principal */}
      <div 
        className={`chat-floating-button ${isOpen && isMinimized ? 'minimized' : ''} ${hasNewMentions ? 'mentions' : ''}`}
        data-page={isTimeTrackerPage ? 'time-tracker' : undefined}
        {...clickableProps}
        onClick={handleClick}
        title="Abrir chat"
        aria-label={unreadCount > 0 ? `Abrir chat: ${unreadCount} não lidas` : 'Abrir chat'}
      >
        {/* Ícone principal */}
        <MessageCircle className="chat-icon" />
        
        {/* Badge de mensagens não lidas */}
        {unreadCount > 0 && (
          <div className="unread-badge">
            {unreadCount > 99 ? '99+' : unreadCount}
          </div>
        )}
        
        {/* Indicador de menções */}
        {hasNewMentions && (
          <div className="mention-indicator" />
        )}
        
        {/* Controles quando minimizado */}
        {isOpen && isMinimized && (
          <div className="minimized-controls">
            <button
              className="control-btn restore"
              onClick={handleRestore}
              title="Restaurar"
            >
              <Maximize2 className="w-3 h-3" />
            </button>
            <button
              className="control-btn close"
              onClick={handleClose}
              title="Fechar"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        )}
        
        {/* Pulse animation para novas mensagens */}
        {(unreadCount > 0 || hasNewMentions) && (
          <div className="pulse-ring" />
        )}
      </div>
      
    </>
  );
};

export default ChatFloatingButton;